import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initMetaPixel, pageView } from "@/lib/metaPixel";

/**
 * Initializes Meta Pixel once at mount and fires PageView on every route change.
 * Silent no-op if REACT_APP_META_PIXEL_ID is not set.
 */
export default function useMetaPixelPageviews() {
  const location = useLocation();
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    // fire PageView on route change (initMetaPixel fires the first one)
    pageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);
}
